"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createItemPayload = exports.createDCO1ClickPayload = exports.createNextInteractionPayload = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("../common/interfaces");
var index_1 = tslib_1.__importDefault(require("../checkoutUrlBuilderApi/index"));
var index_2 = require("./bff/index");
var module_util_1 = require("../../utils/module.util");
var nextInteractionApi = (0, module_util_1.getModules)({
    getNextInteraction: {
        bffFn: index_2.getNextInteraction_bff
    }
});
// exporting for unit test - all flows have been tested
/* istanbul ignore next */
function createNextInteractionPayload(result, input) {
    var _a, _b, _c, _d;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var nextInteractionPayload, payload, _e, request, url, e_1;
        return tslib_1.__generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.interaction)) return [3 /*break*/, 11];
                    nextInteractionPayload = void 0;
                    payload = void 0;
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 10, , 11]);
                    _e = (_b = result.data) === null || _b === void 0 ? void 0 : _b.interaction;
                    switch (_e) {
                        case interfaces_1.Interactions.DEFAULT_CHECKOUT: return [3 /*break*/, 2];
                        case interfaces_1.Interactions.ERROR: return [3 /*break*/, 6];
                        case interfaces_1.Interactions.DCO_1_CLICK_NO_PRIOR_ORDER: return [3 /*break*/, 7];
                        case interfaces_1.Interactions.DCO_1_CLICK: return [3 /*break*/, 7];
                    }
                    return [3 /*break*/, 8];
                case 2:
                    if (!((_c = input.interactions) === null || _c === void 0 ? void 0 : _c.includes(interfaces_1.Interactions.DEFAULT_CHECKOUT))) return [3 /*break*/, 4];
                    request = {
                        successUrl: input.successUrl,
                        errorUrl: input.errorUrl,
                        items: createItemPayload(input),
                        hostAnnotations: input.hostAnnotations,
                        productType: (_d = input.pricingData.productFamily) !== null && _d !== void 0 ? _d : ""
                    };
                    return [4 /*yield*/, index_1.default
                            .getCheckoutUrl(request)
                            .then(function (resp) { var _a; return (_a = resp.data) === null || _a === void 0 ? void 0 : _a.url; })];
                case 3:
                    url = _f.sent();
                    nextInteractionPayload = {
                        action: interfaces_1.Interactions.DEFAULT_CHECKOUT,
                        reason: result.data.reason,
                        loginState: result.data.state,
                        uuid: result.data.uuid,
                        url: url
                    };
                    return [3 /*break*/, 5];
                case 4:
                    nextInteractionPayload = {
                        action: interfaces_1.Interactions.OTHER,
                        reason: result.data.reason,
                        loginState: result.data.state,
                        uuid: result.data.uuid
                    };
                    _f.label = 5;
                case 5: return [3 /*break*/, 9];
                case 6:
                    // Error but in a pending state so we will still show them 1-click
                    payload = createDCO1ClickPayload(result, input);
                    nextInteractionPayload = {
                        action: interfaces_1.Interactions.DCO_1_CLICK,
                        reason: result.data.reason,
                        loginState: result.data.state,
                        uuid: result.data.uuid,
                        payload: payload
                    };
                    return [3 /*break*/, 9];
                case 7:
                    payload = createDCO1ClickPayload(result, input);
                    nextInteractionPayload = {
                        action: result.data.interaction,
                        reason: result.data.reason,
                        loginState: result.data.state,
                        uuid: result.data.uuid,
                        payload: payload
                    };
                    return [3 /*break*/, 9];
                case 8:
                    nextInteractionPayload = {
                        action: interfaces_1.Interactions.OTHER,
                        reason: "No DCO or DCO 1-click interaction"
                    };
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/, {
                        data: nextInteractionPayload,
                        success: true,
                        errors: null
                    }];
                case 10:
                    e_1 = _f.sent();
                    /* istanbul ignore next */
                    return [2 /*return*/, {
                            data: {
                                action: interfaces_1.Interactions.OTHER,
                                reason: "Error while computing interactions"
                            },
                            success: false,
                            errors: [e_1]
                        }];
                case 11: return [2 /*return*/, {
                        data: {
                            action: interfaces_1.Interactions.OTHER,
                            reason: "NO_INTERACTION_FOUND"
                        },
                        success: false,
                        errors: [
                            {
                                message: "No Matching Interaction found",
                                type: interfaces_1.ErrorType.SERVER
                            }
                        ]
                    }];
            }
        });
    });
}
exports.createNextInteractionPayload = createNextInteractionPayload;
// exporting for unit tests
function createDCO1ClickPayload(result, input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var pricingData = input.pricingData, products = input.products, successUrl = input.successUrl, errorUrl = input.errorUrl, authorizeParams = input.authorizeParams, hostAnnotations = input.hostAnnotations, userGeolocation = input.userGeolocation;
    var _l = pricingData.eligibility, price = _l.price, actions = _l.actions, currencyDetails = _l.currencyDetails, order = _l.order, productFamily = pricingData.productFamily, externalId = pricingData.externalId, taxInfo = pricingData.taxInfo;
    /*istanbul ignore next*/
    var payload = {
        eligibility: pricingData,
        successUrl: successUrl,
        errorUrl: errorUrl,
        productType: productFamily,
        authorization: authorizeParams,
        items: createItemPayload(input),
        hostAnnotations: hostAnnotations,
        authState: (_a = result.data) === null || _a === void 0 ? void 0 : _a.state,
        externalId: externalId !== null && externalId !== void 0 ? externalId : price === null || price === void 0 ? void 0 : price.itemDetails.externalId,
        action: actions ? actions[0] : "",
        price: price,
        currencyDetails: currencyDetails,
        taxInfo: taxInfo !== null && taxInfo !== void 0 ? taxInfo : (_b = result.data) === null || _b === void 0 ? void 0 : _b.taxInfo,
        orderLineId: (_d = (_c = order === null || order === void 0 ? void 0 : order.lineItem) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : "",
        mopDetails: (_e = order === null || order === void 0 ? void 0 : order.mopDetails) !== null && _e !== void 0 ? _e : (_f = result.data) === null || _f === void 0 ? void 0 : _f.mopDetails,
        orderDetails: (_j = (_h = (_g = order === null || order === void 0 ? void 0 : order.lineItem) === null || _g === void 0 ? void 0 : _g.details) !== null && _h !== void 0 ? _h : order === null || order === void 0 ? void 0 : order.details) !== null && _j !== void 0 ? _j : (_k = result.data) === null || _k === void 0 ? void 0 : _k.orderDetails,
        userGeolocation: userGeolocation,
        products: products
    };
    return payload;
}
exports.createDCO1ClickPayload = createDCO1ClickPayload;
function createItemPayload(request) {
    var _a, _b, _c, _d, _e, _f;
    var _g = request.pricingData, externalId = _g.externalId, eligibility = _g.eligibility;
    var annotation = eligibility.annotation;
    var dcoItem = {
        externalId: externalId,
        catalogItemId: (_b = (_a = eligibility.price) === null || _a === void 0 ? void 0 : _a.itemDetails.id) !== null && _b !== void 0 ? _b : "",
        experiment: (_d = (_c = eligibility.price) === null || _c === void 0 ? void 0 : _c.experiment) !== null && _d !== void 0 ? _d : "BASE",
        pricingId: (_f = (_e = eligibility.price) === null || _e === void 0 ? void 0 : _e.pricingLogId) !== null && _f !== void 0 ? _f : "",
        productName: request.productName,
        annotation: tslib_1.__assign(tslib_1.__assign({}, request.itemAnnotations), annotation),
        quantity: 1
    };
    return [dcoItem];
}
exports.createItemPayload = createItemPayload;
exports.default = nextInteractionApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/nextInteractionApi/index.js
// module id = 1342
// module chunks = 11